"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeaturedLayoutIdText = exports.featuredLayoutIdToText = exports.checkStagedLayoutAvailable = exports.checkSourceTypeIsPresent = exports.checkLayoutAvailable = void 0;
var _underscore = require("underscore");
var _constants = require("../../constants");
var featuredLayoutIdToText = exports.featuredLayoutIdToText = {
  FEATURED_SCREEN: 'FeaturedScreen_Popover',
  FEATURED_MEDIA: 'FeaturedMedia_Popover',
  FEATURED_PRESENTER: 'FeaturedPresenter_Popover',
  SIDE_BY_SIDE: 'SideBySide_Popover',
  GRID: 'Grid_Popover'
};
var getFeaturedLayoutIdText = exports.getFeaturedLayoutIdText = function getFeaturedLayoutIdText(id) {
  if (id === 'FEATURED_MEDIA') {
    return 'FeaturedContent_Popover';
  }
  return featuredLayoutIdToText[id];
};
var checkSourceTypeIsPresent = exports.checkSourceTypeIsPresent = function checkSourceTypeIsPresent() {
  var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sources = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var stagedSources = arguments.length > 2 ? arguments[2] : undefined;
  var stagedSourcesIds = Object.keys(stagedSources);
  return sources.reduce(function (acc, curr) {
    // first check is to confirm there are sources of the type supplied
    var firstCheck = types.includes(curr === null || curr === void 0 ? void 0 : curr.type) && !(curr !== null && curr !== void 0 && curr.hidden);

    // if the first check is successful, we want to check if the current source is
    // staged but toggled off
    if (firstCheck && stagedSourcesIds.length) {
      var secondCheck = stagedSourcesIds.includes(curr._id) && !stagedSources[curr._id];

      // if it's toggled off, we should return false.
      // If it's not, we want to confirm if the previous value of the reduce function
      // is different from the value of the first check. If yes, we want to return true,
      // if not, return false.
      return secondCheck ? false : firstCheck && !acc ? true : acc;
    }
    return acc ? acc : firstCheck;
  }, false);
};
var checkLayoutAvailable = exports.checkLayoutAvailable = function checkLayoutAvailable(layoutId, sources) {
  var stagedSources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var hasSourceTypes = function hasSourceTypes(types) {
    return checkSourceTypeIsPresent(types, sources, stagedSources);
  };
  switch (layoutId) {
    case 'FEATURED_MEDIA':
      return hasSourceTypes([_constants.VIDEO_FILE, _constants.IMAGE_FILE, _constants.PDF_FILE]) && hasSourceTypes([_constants.CAMERA_PRESENTER]);
    case 'FEATURED_SCREEN':
      return hasSourceTypes([_constants.SCREEN_PRESENTER]) && hasSourceTypes([_constants.CAMERA_PRESENTER]);
    default:
      return hasSourceTypes([_constants.CAMERA_PRESENTER]);
  }
};
var checkStagedLayoutAvailable = exports.checkStagedLayoutAvailable = function checkStagedLayoutAvailable(sceneLayout, stagedLayout) {
  if ((0, _underscore.isEqual)(stagedLayout, _constants.GRID)) {
    // Make other camera sources only layouts  available
    return [_constants.GRID, _constants.SIDE_BY_SIDE, _constants.FEATURED_PRESENTER].some(function (sl) {
      return sl.id === sceneLayout.id;
    });
  }
  return sceneLayout.id === stagedLayout.id;
};